import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import BasicEditor from 'shared/editor/Basic'
import themeVars from 'ui_theme/site/globals/site.variables'

require('shared/editor/plugins/groove-mentions')

class NoteEditor extends React.Component {
  constructor(props) {
    super(props)
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.config = {
      ...this.rootConfig,
      ...props.config,
    }
  }

  state = {
    config: {},
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.config !== !this.props.config) {
      this.setState({
        config: {
          ...this.rootConfig,
          ...nextProps.config,
        },
      })
    }
  }

  shouldComponentUpdate(nextProps) {
    // HACK (jscheel): Editor was re-rendering when it shouldn't, so we are being
    // a bit more heavy-handed and explicit that nothing should be changing.
    const keys = Object.keys(this.props)
    for (let i = keys.length - 1; i >= 0; i -= 1) {
      const key = keys[i]
      if (this.props[key] !== nextProps[key]) {
        return true
      }
    }
    return false
  }

  onMention = event => {
    if (this.props.onMention) this.props.onMention(event.mention)
  }

  setupMention = editor => {
    editor.on('mention-change', this.onMention)
  }

  rootConfig = {
    inline: true,
    body_class: 'editor-note',
    plugins:
      'groove-paste-cleanup groove-before-set-content-cleanup groove-mentions paste autoresize groove-inline-placeholder groove-emojis',
    autoresize_bottom_margin: 0,
    autoresize_min_height: 60,
    autoresize_max_height: 300,
    autoresize_on_init: true,
    toolbar: false,
    forced_root_block: 'div',
  }

  render() {
    const { className, content, ...rest } = this.props
    const { config } = this.state

    return (
      <BasicEditor
        {...rest}
        className={cn(className, 'toolbar-bottom', 'noteEditor')}
        config={config}
        initialValue={content}
        onSetup={this.setupMention}
        placeholder="Log a recent conversation you’ve had with a customer here…"
        placeholderStyle={{
          paddingLeft: 0,
          width: '100%',
          'white-space': 'normal',
        }}
        inline={config.inline}
      />
    )
  }
}

export default styled(NoteEditor)`
  &&& {
    font-family: ${themeVars.pageFont};
    font-size: 14px;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    font-weight: 400;
    line-height: 1.4285em;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0;
    padding: 0;
    overflow: auto;
    min-height: 60px;
  }

  width: 100%;
  flex: 2 1 auto;

  & > .mce-content-body {
    min-height: 60px;
  }

  .mce-content-body p {
    margin-bottom: 0;
    line-height: 1.4;
  }

  .mce-content-body {
    outline: 0;
  }

  .mce-content-body .mention {
    font-weight: 500;
  }

  .mce-edit-area,
  .mce-panel,
  .mce-toolbar-grp,
  .mce-btn {
    background-color: ${props => props.theme.color.secondary.warning};
  }
`
